import {
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
  await1kke5zj2piplv as await_0,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  MonetaryValue__times_impl_hlr6p71hn0xcq6so58l as MonetaryValue__times_impl_hlr6p7,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  LineItemInterface2ct3y0vtnbxod as LineItemInterface,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  MonetaryValue__div_impl_3meibk17hx1lxlelhgh as MonetaryValue__div_impl_3meibk,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  modify2eca96i8s7hc2 as modify,
  set_value1vvx5pkb20ebv as set_value,
  interceptWrite2xi6g5kl52xuu as interceptWrite,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  isBlank1dvkhjjvox3p0 as isBlank,
  substringAfterLastuw9v7gfiiihe as substringAfterLast,
  substringBeforekje8w2lxhyb6 as substringBefore,
  substringBefore3n7kj60w69hju as substringBefore_0,
  substringAfter1hku067gwr5ve as substringAfter,
  substringBeforeLast14532pi2uwutw as substringBeforeLast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from './files/attachmentFilePreview.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toIntOrNull3w2d066r9pvwm as toIntOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringNumberConversions.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { ReactiveWithMutableValue1h1r6ig7acce5 as ReactiveWithMutableValue } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
import {
  MutableValidated2ognu5vxf17ur as MutableValidated,
  get_issues1z1skb5sgeygq as get_issues,
} from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import {
  assertNotBlankNamed365y7czhf0np3 as assertNotBlankNamed,
  validategsg6go7eyi9d as validate,
} from '../../utils/validation.mjs';
import { assert3pektuc8qw5gc as assert } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { TargetHandler15cm4auxqf0yk as TargetHandler } from '../../utils/RequestFocus.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './nav/AppDimensions.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  Companion_getInstance2v0f9t0g75gcs as Companion_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { bodyBold2czwdzwknab0k as bodyBold } from '../theming/Titles.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from './MonetaryValueInput.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_0,
  toDuration28gf6ughsr3vf as toDuration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { debounceWritek53gh4jhz3o8 as debounceWrite } from '../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { get_viewIsWide3s4g60a9e0192 as get_viewIsWide } from './nav/crowpay.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from './files/renderFiles.mjs';
import { fileManager1pvd5zvbyt8nt as fileManager } from './files/fileManager.mjs';
import { lazygopf2ohairjp as lazy } from '../../utils/utils.mjs';
import { label287uhiq3m9m4z as label2 } from './label2.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Form39thjb3imm7id as Form } from './nav/header.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$interceptWrite, qty, $completion) {
  var tmp = awaitOnce($this.rg8_1.og8_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.rg8_1.ng8_1.gah(new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7(tmp.a5s_1, qty)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = modify($this.rg8_1.ig8_1, LineItemForm$quantity$slambda$slambda_0($this.rg8_1, qty), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  set_value($this$interceptWrite, qty);
  return Unit_instance;
}
var LineItemForm$quantity$slambda$slambdaClass;
function LineItemForm$quantity$slambda$slambda() {
  if (LineItemForm$quantity$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $qty) {
        this.sg8_1 = this$0;
        this.tg8_1 = $qty;
      }
      ug8(it, $completion) {
        var tmp0_elvis_lhs = parseUnit(this.sg8_1, it);
        var unit = tmp0_elvis_lhs == null ? ReactiveState__getOrNull_impl_1asnfp(this.sg8_1.kg8_1.qah()) : tmp0_elvis_lhs;
        return !(unit == null) ? addQuantityAndUnit$default(this.sg8_1, it, this.tg8_1, unit) : addQuantity(this.sg8_1, it, this.tg8_1);
      }
      s2(p1, $completion) {
        return this.ug8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemForm$quantity$slambda$slambdaClass = $;
  }
  return LineItemForm$quantity$slambda$slambdaClass;
}
function LineItemForm$quantity$slambda$slambda_0(this$0, $qty) {
  var i = new (LineItemForm$quantity$slambda$slambda())(this$0, $qty);
  var l = (it, $completion) => i.ug8(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$interceptWrite, unit, $completion) {
  var tmp = modify($this.vg8_1.ig8_1, LineItemForm$unit$slambda$slambda_0($this.vg8_1, unit), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  set_value($this$interceptWrite, unit);
  return Unit_instance;
}
var LineItemForm$unit$slambda$slambdaClass;
function LineItemForm$unit$slambda$slambda() {
  if (LineItemForm$unit$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $unit) {
        this.wg8_1 = this$0;
        this.xg8_1 = $unit;
      }
      ug8(full, $completion) {
        var qty = parseQuantity(this.wg8_1, full);
        var tmp = qty == null ? 1 : qty;
        // Inline function 'kotlin.text.isNotBlank' call
        var this_0 = this.xg8_1;
        var tmp$ret$0 = !isBlank(this_0);
        return addQuantityAndUnit(this.wg8_1, full, tmp, this.xg8_1, tmp$ret$0);
      }
      s2(p1, $completion) {
        return this.ug8((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemForm$unit$slambda$slambdaClass = $;
  }
  return LineItemForm$unit$slambda$slambdaClass;
}
function LineItemForm$unit$slambda$slambda_0(this$0, $unit) {
  var i = new (LineItemForm$unit$slambda$slambda())(this$0, $unit);
  var l = (full, $completion) => i.ug8(full, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$interceptWrite, it, $completion) {
  var tmp = $this.yg8_1.og8_1.gah(new (MonetaryValue())(Companion_instance.o62(0)), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this$interceptWrite.gah(new (MonetaryValue())(it), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$interceptWrite, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.zg8_1.jg8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.zg8_1.ng8_1.gah(new (MonetaryValue())(MonetaryValue__times_impl_hlr6p7(it, tmp$ret$0)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  set_value($this$interceptWrite, new (MonetaryValue())(it));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(tmp$ret$0.tfw().efg_1);
}
var LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.ag9_1 = p0;
      }
      sao($completion) {
        return this.ag9_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2LineItemLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_2(tmp$ret$0.tfw().efg_1);
}
var LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass_0;
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_1() {
  if (LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass_0 === VOID) {
    class $ {
      constructor(p0) {
        this.bg9_1 = p0;
      }
      sao($completion) {
        return this.bg9_1.jfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass_0 = $;
  }
  return LiveApi2$Api2LineItemLive$uploadFileForRequest$refClass_0;
}
function LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_2(p0) {
  var i = new (LiveApi2$Api2LineItemLive$uploadFileForRequest$ref_1())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.cg9_1.eg8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = resolveProjectAttachments(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function parseQuantityAndUnit($this, _this__u8e3s4) {
  // Inline function 'kotlin.takeUnless' call
  var this_0 = substringBefore(substringAfterLast(_this__u8e3s4, ' (', ''), ')', '');
  var tmp;
  if (!isBlank(this_0)) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
function parseQuantity($this, _this__u8e3s4) {
  var tmp0_safe_receiver = parseQuantityAndUnit($this, _this__u8e3s4);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : substringBefore_0(tmp0_safe_receiver, _Char___init__impl__6a9atx(32));
  return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
}
function parseUnit($this, _this__u8e3s4) {
  var tmp0_safe_receiver = parseQuantityAndUnit($this, _this__u8e3s4);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : substringAfter(tmp0_safe_receiver, _Char___init__impl__6a9atx(32), '');
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeUnless' call
    var tmp_0;
    if (!isBlank(tmp1_safe_receiver)) {
      tmp_0 = tmp1_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function addQuantity($this, _this__u8e3s4, qty) {
  var unit = parseUnit($this, _this__u8e3s4);
  var tmp;
  if (qty === 1) {
    tmp = '';
  } else {
    // Inline function 'kotlin.text.isNullOrBlank' call
    if (unit == null || isBlank(unit)) {
      tmp = ' (' + qty + ')';
    } else {
      tmp = ' (' + qty + ' ' + unit + ')';
    }
  }
  var suffix = tmp;
  return substringBeforeLast(_this__u8e3s4, ' (') + suffix;
}
function addQuantityAndUnit($this, _this__u8e3s4, qty, unit, force) {
  var suffix = qty === 1 && !force ? '' : isBlank(unit) ? ' (' + qty + ')' : ' (' + qty + ' ' + unit + ')';
  return substringBeforeLast(_this__u8e3s4, ' (') + suffix;
}
function addQuantityAndUnit$default($this, _this__u8e3s4, qty, unit, force, $super) {
  force = force === VOID ? false : force;
  return addQuantityAndUnit($this, _this__u8e3s4, qty, unit, force);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.dg9_1 = 0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function LineItemForm$saved$lambda(it) {
  return !it;
}
function LineItemForm$nameAndQuantityAndUnit$lambda(it) {
  return it.k20();
}
function LineItemForm$nameAndQuantityAndUnit$lambda_0(og, it) {
  var tmp;
  if (og instanceof LineItem()) {
    var tmp_0 = og.i6l(VOID, VOID, VOID, VOID, VOID, it);
    tmp = isInterface(tmp_0, LineItemInterface()) ? tmp_0 : THROW_CCE();
  } else {
    if (og instanceof PendingLineItem()) {
      var tmp_1 = og.m76(VOID, VOID, VOID, it);
      tmp = isInterface(tmp_1, LineItemInterface()) ? tmp_1 : THROW_CCE();
    } else {
      tmp = og;
    }
  }
  return tmp;
}
var LineItemForm$quantity$slambdaClass;
function LineItemForm$quantity$slambda() {
  if (LineItemForm$quantity$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rg8_1 = this$0;
      }
      eg9($this$interceptWrite, qty, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$interceptWrite, qty), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, ReactiveWithMutableValue()) : false) ? p1 : THROW_CCE();
        return this.eg9(tmp, (!(p2 == null) ? typeof p2 === 'number' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    LineItemForm$quantity$slambdaClass = $;
  }
  return LineItemForm$quantity$slambdaClass;
}
function LineItemForm$quantity$slambda_0(this$0) {
  var i = new (LineItemForm$quantity$slambda())(this$0);
  var l = ($this$interceptWrite, qty, $completion) => i.eg9($this$interceptWrite, qty, $completion);
  l.$arity = 2;
  return l;
}
var LineItemForm$unit$slambdaClass;
function LineItemForm$unit$slambda() {
  if (LineItemForm$unit$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.vg8_1 = this$0;
      }
      fg9($this$interceptWrite, unit, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$interceptWrite, unit), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, ReactiveWithMutableValue()) : false) ? p1 : THROW_CCE();
        return this.fg9(tmp, (!(p2 == null) ? typeof p2 === 'string' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    LineItemForm$unit$slambdaClass = $;
  }
  return LineItemForm$unit$slambdaClass;
}
function LineItemForm$unit$slambda_0(this$0) {
  var i = new (LineItemForm$unit$slambda())(this$0);
  var l = ($this$interceptWrite, unit, $completion) => i.fg9($this$interceptWrite, unit, $completion);
  l.$arity = 2;
  return l;
}
function LineItemForm$name$lambda(it) {
  return substringBeforeLast(it, ' (');
}
function LineItemForm$description$lambda(it) {
  return it.q91();
}
function LineItemForm$description$lambda_0(og, it) {
  var tmp;
  if (og instanceof LineItem()) {
    var tmp_0 = og.i6l(VOID, VOID, VOID, VOID, VOID, VOID, it);
    tmp = isInterface(tmp_0, LineItemInterface()) ? tmp_0 : THROW_CCE();
  } else {
    if (og instanceof PendingLineItem()) {
      var tmp_1 = og.m76(VOID, VOID, VOID, VOID, it);
      tmp = isInterface(tmp_1, LineItemInterface()) ? tmp_1 : THROW_CCE();
    } else {
      tmp = og;
    }
  }
  return tmp;
}
function LineItemForm$price$lambda(it) {
  return new (MonetaryValue())(it.v91());
}
function LineItemForm$price$lambda_0(og, it) {
  var tmp;
  if (og instanceof LineItem()) {
    var tmp_0 = og.i6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, it.a5s_1);
    tmp = isInterface(tmp_0, LineItemInterface()) ? tmp_0 : THROW_CCE();
  } else {
    if (og instanceof PendingLineItem()) {
      var tmp_1 = og.m76(VOID, VOID, VOID, VOID, VOID, it.a5s_1);
      tmp = isInterface(tmp_1, LineItemInterface()) ? tmp_1 : THROW_CCE();
    } else {
      tmp = og;
    }
  }
  return tmp;
}
function LineItemForm$price$lambda_1(it) {
  return MonetaryValue__compareTo_impl_w7ul1r(it.a5s_1, Companion_instance.p91(0n)) > 0;
}
function TextInput$_get_enabled_$ref_3dkh3c(p0) {
  return () => p0.dbs();
}
function TextInput$_set_enabled_$ref_xnynf8(p0) {
  return (_this__u8e3s4) => {
    p0.cbs(_this__u8e3s4);
    return Unit_instance;
  };
}
function MonetaryValueInput$_get_enabled_$ref_ui2o9t(p0) {
  return () => p0.dbs();
}
function MonetaryValueInput$_set_enabled_$ref_7ohxx(p0) {
  return (_this__u8e3s4) => {
    p0.cbs(_this__u8e3s4);
    return Unit_instance;
  };
}
var LineItemForm$render$slambdaClass;
function LineItemForm$render$slambda() {
  if (LineItemForm$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.yg8_1 = this$0;
      }
      sg9($this$interceptWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$interceptWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, MutableValidated()) : false) ? p1 : THROW_CCE();
        return this.sg9(tmp, p2 instanceof MonetaryValue() ? p2.a5s_1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    LineItemForm$render$slambdaClass = $;
  }
  return LineItemForm$render$slambdaClass;
}
function LineItemForm$render$slambda_0(this$0) {
  var i = new (LineItemForm$render$slambda())(this$0);
  var l = ($this$interceptWrite, it, $completion) => i.sg9($this$interceptWrite, it.a5s_1, $completion);
  l.$arity = 2;
  return l;
}
function NumberInput$_get_enabled_$ref_s5mkf0(p0) {
  return () => p0.dbs();
}
function NumberInput$_set_enabled_$ref_24rlww(p0) {
  return (_this__u8e3s4) => {
    p0.cbs(_this__u8e3s4);
    return Unit_instance;
  };
}
function MonetaryValueInput$_get_enabled_$ref_ui2o9t_0(p0) {
  return () => p0.dbs();
}
function MonetaryValueInput$_set_enabled_$ref_7ohxx_0(p0) {
  return (_this__u8e3s4) => {
    p0.cbs(_this__u8e3s4);
    return Unit_instance;
  };
}
var LineItemForm$render$slambdaClass_0;
function LineItemForm$render$slambda_1() {
  if (LineItemForm$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.zg8_1 = this$0;
      }
      tg9($this$interceptWrite, it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$interceptWrite, it), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, ReactiveWithMutableValue()) : false) ? p1 : THROW_CCE();
        return this.tg9(tmp, p2 instanceof MonetaryValue() ? p2.a5s_1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    LineItemForm$render$slambdaClass_0 = $;
  }
  return LineItemForm$render$slambdaClass_0;
}
function LineItemForm$render$slambda_2(this$0) {
  var i = new (LineItemForm$render$slambda_1())(this$0);
  var l = ($this$interceptWrite, it, $completion) => i.tg9($this$interceptWrite, it.a5s_1, $completion);
  l.$arity = 2;
  return l;
}
function TextArea$_get_enabled_$ref_mw14xh(p0) {
  return () => p0.dbs();
}
function TextArea$_set_enabled_$ref_7ed1ef(p0) {
  return (_this__u8e3s4) => {
    p0.cbs(_this__u8e3s4);
    return Unit_instance;
  };
}
var LineItemForm$render$lambda$slambdaClass;
function LineItemForm$render$lambda$slambda() {
  if (LineItemForm$render$lambda$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemForm$render$lambda$slambdaClass = $;
  }
  return LineItemForm$render$lambda$slambdaClass;
}
function LineItemForm$render$lambda$slambda_0() {
  var i = new (LineItemForm$render$lambda$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LineItemForm$render$lambda$lambda$slambdaClass;
function LineItemForm$render$lambda$lambda$slambda() {
  if (LineItemForm$render$lambda$lambda$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    LineItemForm$render$lambda$lambda$slambdaClass = $;
  }
  return LineItemForm$render$lambda$lambda$slambdaClass;
}
function LineItemForm$render$lambda$lambda$slambda_0() {
  var i = new (LineItemForm$render$lambda$lambda$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var LineItemForm$render$lambda$lambda$slambdaClass_0;
function LineItemForm$render$lambda$lambda$slambda_1() {
  if (LineItemForm$render$lambda$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.cg9_1 = this$0;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    LineItemForm$render$lambda$lambda$slambdaClass_0 = $;
  }
  return LineItemForm$render$lambda$lambda$slambdaClass_0;
}
function LineItemForm$render$lambda$lambda$slambda_2(this$0) {
  var i = new (LineItemForm$render$lambda$lambda$slambda_1())(this$0);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var LineItemFormClass;
function LineItemForm() {
  if (LineItemFormClass === VOID) {
    class $ {
      constructor(line, files, validateWhen, allowEditing) {
        allowEditing = allowEditing === VOID ? null : allowEditing;
        this.dg8_1 = line;
        this.eg8_1 = files;
        this.fg8_1 = validateWhen;
        this.gg8_1 = allowEditing;
        var tmp = this;
        var tmp_0 = this.dg8_1.aak();
        tmp.hg8_1 = lens(tmp_0, LineItemForm$saved$lambda);
        var tmp_1 = this;
        var tmp_2 = LineItemForm$nameAndQuantityAndUnit$lambda;
        tmp_1.ig8_1 = this.dg8_1.bak(tmp_2, LineItemForm$nameAndQuantityAndUnit$lambda_0);
        var tmp_3 = this;
        var tmp_4 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          var tmp0_elvis_lhs = parseQuantity(this, $this$mutableRemember.eaj(this.ig8_1));
          return tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
        });
        tmp_3.jg8_1 = interceptWrite(tmp_4, LineItemForm$quantity$slambda_0(this));
        var tmp_5 = this;
        var tmp_6 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          var tmp0_elvis_lhs = parseUnit(this, $this$mutableRemember.eaj(this.ig8_1));
          return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        });
        tmp_5.kg8_1 = interceptWrite(tmp_6, LineItemForm$unit$slambda_0(this));
        var tmp_7 = this;
        var tmp_8 = LineItemForm$name$lambda;
        tmp_7.lg8_1 = assertNotBlankNamed(this.ig8_1.bak(tmp_8, (nameAndQty, name) => {
          var qAndU = parseQuantityAndUnit(this, nameAndQty);
          return qAndU == null ? name : name + ' (' + qAndU + ')';
        }), 'Name');
        var tmp_9 = this;
        var tmp_10 = LineItemForm$description$lambda;
        tmp_9.mg8_1 = this.dg8_1.bak(tmp_10, LineItemForm$description$lambda_0);
        var tmp_11 = this;
        var tmp_12 = LineItemForm$price$lambda;
        var tmp_13 = this.dg8_1.bak(tmp_12, LineItemForm$price$lambda_0);
        tmp_11.ng8_1 = assert(tmp_13, 'Must be greater than 0', 'Price must be greater than 0', VOID, LineItemForm$price$lambda_1);
        var tmp_14 = this;
        tmp_14.og8_1 = mutableRemember(VOID, VOID, ($this$mutableRemember) => {
          var q = $this$mutableRemember.eaj(this.jg8_1);
          return new (MonetaryValue())(q === 0 ? Companion_instance.o62(0) : MonetaryValue__div_impl_3meibk($this$mutableRemember.eaj(this.ng8_1).a5s_1, q));
        });
        var tmp_15 = this;
        Companion_instance_0.dg9_1 = Companion_instance_0.dg9_1 + 1 | 0;
        tmp_15.pg8_1 = Companion_instance_0.dg9_1;
        this.qg8_1 = new (TargetHandler())('LineItemForm ' + this.pg8_1);
      }
      ug9() {
        return this.hg8_1;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().hg2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        var tmp = get_expanding(view_0);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'Work Item Title';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(false);
        view_2.zb8(get_AppDimensions().pg2_1);
        view_2.jbb(get_centered(view_2), bodyBold(view_2, label));
        view_2.jbb(colored(view_2, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_2, '*'));
        view_1.fbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_0 = view_1.hbb(FieldSemantic_getInstance());
        var tmp_1 = validate(view_1, this.lg8_1, this.fg8_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextInput())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.ebb(p_3, view_3);
        var tmp0_safe_receiver = this.gg8_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it = tmp0_safe_receiver;
          var tmp_2 = KMutableProperty0();
          var tmp_3 = TextInput$_get_enabled_$ref_3dkh3c(view_3);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('enabled', 0, tmp_2, tmp_3, TextInput$_set_enabled_$ref_xnynf8(view_3));
          reactiveScope(view_3, ($this$reactiveScope) => {
            var tmp$ret$5 = $this$reactiveScope.baj(it);
            this_0.set(tmp$ret$5);
            return Unit_instance;
          });
        }
        view_3.abs(Companion_getInstance().qd5_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_3.tb5_1.zb3_1.ib7_1.placeholder = 'Name';
        view_3.xah(view_3.gcn_1, this.lg8_1);
        this.qg8_1.lg5(view_3);
        view_1.fbb(p_3, view_3);
        view_1.jbb(tmp_1, view_3);
        var tmp$ret$14 = issueText(view_1, get_issues(this.lg8_1), VOID, this.fg8_1);
        view_1.jbb(tmp_0, tmp$ret$14);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp, view_1);
        var tmp_4 = get_expanding(view_0);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_0 = 'Total Price (Dollars)';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.ebb(p_4, view_4);
        view_4.xbm(true);
        view_4.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        view_5.xbm(false);
        view_5.zb8(get_AppDimensions().pg2_1);
        view_5.jbb(get_centered(view_5), bodyBold(view_5, label_0));
        view_5.jbb(colored(view_5, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_5, '*'));
        view_4.fbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_5 = view_4.hbb(FieldSemantic_getInstance());
        var tmp_6 = validate(view_4, this.ng8_1, this.fg8_1);
        // Inline function 'com.crowpay.views.components.monetaryValueInput' call
        // Inline function 'kotlin.also' call
        var this_1 = new (MonetaryValueInput())(view_4);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = MonetaryValueInput$_get_enabled_$ref_ui2o9t(this_1);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, MonetaryValueInput$_set_enabled_$ref_7ohxx(this_1));
        reactiveScope(view_4, ($this$reactiveScope) => {
          var tmp0_safe_receiver = this.gg8_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$reactiveScope.baj(tmp0_safe_receiver);
          var tmp$ret$25 = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
          this_2.set(tmp$ret$25);
          return Unit_instance;
        });
        this_1.tcl('Price');
        view_4.xah(this_1.gg9_1, interceptWrite(this.ng8_1, LineItemForm$render$slambda_0(this)));
        var tmp$ret$29 = this_1.jg9_1;
        view_4.jbb(tmp_6, tmp$ret$29);
        var tmp$ret$30 = issueText(view_4, get_issues(this.ng8_1), VOID, this.fg8_1);
        view_4.jbb(tmp_5, tmp$ret$30);
        view_0.fbb(p_4, view_4);
        view_0.jbb(tmp_4, view_4);
        view.fbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint_0 = get_AppDimensions().hg2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint_0)));
        var tmp0_elvis_lhs_6 = view.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
        view.ebb(p_6, view_6);
        var tmp_9 = get_expanding(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (RowOrCol())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.ebb(p_7, view_7);
        view_7.xbm(false);
        var tmp_10 = get_expanding(view_7);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_1 = 'Quantity';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_7.pc());
        var tmp0_elvis_lhs_8 = view_7.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
        view_7.ebb(p_8, view_8);
        view_8.xbm(true);
        view_8.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_8, label_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_11 = view_8.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (NumberInput())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.ebb(p_9, view_9);
        var tmp0_safe_receiver_0 = this.gg8_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_0 = tmp0_safe_receiver_0;
          var tmp_12 = KMutableProperty0();
          var tmp_13 = NumberInput$_get_enabled_$ref_s5mkf0(view_9);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_3 = getPropertyCallableRef('enabled', 0, tmp_12, tmp_13, NumberInput$_set_enabled_$ref_24rlww(view_9));
          reactiveScope(view_9, ($this$reactiveScope) => {
            var tmp$ret$40 = $this$reactiveScope.baj(it_0);
            this_3.set(tmp$ret$40);
            return Unit_instance;
          });
        }
        view_9.abs(Companion_getInstance().sd5_1);
        view_9.bbs(Align_Start_getInstance());
        var keep = {_v: false};
        var tmp_14 = (it) => {
          // Inline function 'kotlin.takeUnless' call
          var tmp;
          if (!(it === 1 && !keep._v)) {
            tmp = it;
          } else {
            tmp = null;
          }
          var tmp0_safe_receiver = tmp;
          return tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
        };
        var tmp_15 = this.jg8_1.tak(tmp_14, (it) => {
          keep._v = !(it == null);
          var tmp1_elvis_lhs = it == null ? null : numberToInt(it);
          return tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
        });
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance_0();
        var tmp$ret$46 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
        view_9.xah(view_9.xc5_1, debounceWrite(tmp_15, tmp$ret$46));
        view_8.fbb(p_9, view_9);
        view_8.jbb(tmp_11, view_9);
        view_8.jbb(view_8.hbb(SubtextSemantic_getInstance()), errorText(view_8));
        view_7.fbb(p_8, view_8);
        view_7.jbb(tmp_10, view_8);
        var tmp_16 = get_expanding(view_7);
        // Inline function 'com.crowpay.views.components.field2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (RowOrCol())(view_7.pc());
        var tmp0_elvis_lhs_10 = view_7.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_7 : tmp0_elvis_lhs_10;
        view_7.ebb(p_10, view_10);
        view_10.xbm(true);
        view_10.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_10, 'Unit');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_17 = view_10.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (TextInput())(view_10.pc());
        var tmp0_elvis_lhs_11 = view_10.cbb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
        view_10.ebb(p_11, view_11);
        view_11.xah(view_11.gcn_1, this.kg8_1);
        view_10.fbb(p_11, view_11);
        view_10.jbb(tmp_17, view_11);
        view_10.jbb(view_10.hbb(SubtextSemantic_getInstance()), errorText(view_10));
        view_7.fbb(p_10, view_10);
        view_7.jbb(tmp_16, view_10);
        view_6.fbb(p_7, view_7);
        view_6.jbb(tmp_9, view_7);
        var tmp_18 = get_expanding(view_6);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_2 = 'Unit Price (Dollars)';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_6.pc());
        var tmp0_elvis_lhs_12 = view_6.cbb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_6 : tmp0_elvis_lhs_12;
        view_6.ebb(p_12, view_12);
        view_12.xbm(true);
        view_12.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_12, label_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_19 = view_12.hbb(FieldSemantic_getInstance());
        var tmp_20 = validate(view_12, this.ng8_1, this.fg8_1);
        // Inline function 'com.crowpay.views.components.monetaryValueInput' call
        // Inline function 'kotlin.also' call
        var this_4 = new (MonetaryValueInput())(view_12);
        var tmp_21 = KMutableProperty0();
        var tmp_22 = MonetaryValueInput$_get_enabled_$ref_ui2o9t_0(this_4);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_5 = getPropertyCallableRef('enabled', 0, tmp_21, tmp_22, MonetaryValueInput$_set_enabled_$ref_7ohxx_0(this_4));
        reactiveScope(view_12, ($this$reactiveScope) => {
          var tmp0_safe_receiver = this.gg8_1;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : $this$reactiveScope.baj(tmp0_safe_receiver);
          var tmp$ret$71 = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
          this_5.set(tmp$ret$71);
          return Unit_instance;
        });
        this_4.tcl('Price');
        view_12.xah(this_4.gg9_1, interceptWrite(this.og8_1, LineItemForm$render$slambda_2(this)));
        var tmp$ret$75 = this_4.jg9_1;
        view_12.jbb(tmp_20, tmp$ret$75);
        var tmp$ret$76 = issueText(view_12, get_issues(this.ng8_1), VOID, this.fg8_1);
        view_12.jbb(tmp_19, tmp$ret$76);
        view_12.jbb(view_12.hbb(SubtextSemantic_getInstance()), errorText(view_12));
        view_6.fbb(p_12, view_12);
        view_6.jbb(tmp_18, view_12);
        view.fbb(p_6, view_6);
        // Inline function 'com.crowpay.views.components.field2' call
        var label_3 = 'Description';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_13 = view.cbb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
        view.ebb(p_13, view_13);
        view_13.xbm(true);
        view_13.zb8(get_AppDimensions().ng2_1);
        bodyBold(view_13, label_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_23 = view_13.hbb(FieldSemantic_getInstance());
        if (get_viewIsWide(view_13)) {
          sizeConstraints(view_13, VOID, VOID, get_rem(7));
        }
        var tmp_24 = validate(view_13, this.mg8_1, this.fg8_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (TextArea())(view_13.pc());
        var tmp0_elvis_lhs_14 = view_13.cbb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
        view_13.ebb(p_14, view_14);
        var tmp0_safe_receiver_1 = this.gg8_1;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var it_1 = tmp0_safe_receiver_1;
          var tmp_25 = KMutableProperty0();
          var tmp_26 = TextArea$_get_enabled_$ref_mw14xh(view_14);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_6 = getPropertyCallableRef('enabled', 0, tmp_25, tmp_26, TextArea$_set_enabled_$ref_7ed1ef(view_14));
          reactiveScope(view_14, ($this$reactiveScope) => {
            var tmp$ret$86 = $this$reactiveScope.baj(it_1);
            this_6.set(tmp$ret$86);
            return Unit_instance;
          });
        }
        view_14.tcl('Description');
        view_14.xah(view_14.qcl_1, this.mg8_1);
        view_13.fbb(p_14, view_14);
        view_13.jbb(tmp_24, view_14);
        var tmp$ret$93 = issueText(view_13, get_issues(this.mg8_1), VOID, this.fg8_1);
        view_13.jbb(tmp_23, tmp$ret$93);
        view_13.jbb(view_13.hbb(SubtextSemantic_getInstance()), errorText(view_13));
        view.fbb(p_13, view_13);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_15 = view.cbb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view : tmp0_elvis_lhs_15;
        view.ebb(p_15, view_15);
        view_15.xbm(true);
        label2(view_15, 'Files (Images, Specs, Info Related to Work this Item)', VOID, ($this$label2) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (Frame())($this$label2.pc());
          var tmp0_elvis_lhs = $this$label2.cbb_1;
          var p = tmp0_elvis_lhs == null ? $this$label2 : tmp0_elvis_lhs;
          $this$label2.ebb(p, view);
          if (this.gg8_1 == null) {
            // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
            var tmp = view.hbb(FieldSemantic_getInstance());
            view.jbb(tmp, fileManager(view, this.eg8_1, 'No Files Uploaded', VOID, VOID, LineItemForm$render$lambda$slambda_0()));
          } else {
            lazy(view, this.gg8_1, ($this$lazy, edit) => {
              if (edit) {
                // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
                var tmp = $this$lazy.hbb(FieldSemantic_getInstance());
                $this$lazy.jbb(tmp, fileManager($this$lazy, this.eg8_1, 'No Files Uploaded', VOID, VOID, LineItemForm$render$lambda$lambda$slambda_0()));
              } else {
                renderFiles($this$lazy, rememberSuspending(VOID, VOID, VOID, LineItemForm$render$lambda$lambda$slambda_2(this)), get_AppDimensions().qg2_1);
              }
              return Unit_instance;
            });
          }
          $this$label2.fbb(p, view);
          return view;
        });
        view.fbb(p_15, view_15);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'LineItemForm', VOID, VOID, [Page(), Form()]);
    LineItemFormClass = $;
  }
  return LineItemFormClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  LineItemForm as LineItemForm37miaqqv1b4u9,
};
//endregion

//# sourceMappingURL=LineItemForm.mjs.map
